const httpLib = require('./http-library.js');
const publicConfig = require('../public-config.js');

const ssoHost = publicConfig.external_address;

exports.ActionStore = {
  readToken: function readToken (inviteToken, callback) {
    const params = {
      host: ssoHost,
      method: 'GET',
      path: `/v1/action-store/external/${inviteToken}`
    };
    httpLib.request(params, function (res) {
      callback(res);
    });
  }
};
